<template>
<div id="registration">
    <div class="container" style="margin-bottom: 50px;">
        <div class="row">
            <h1 style="text-align: center;" >Регистрация</h1>
            <br>
            <div class="alert alert-danger" role="alert" v-if="errors" v-html="errors"></div>
            <div>

                <div class="form-group col-md-offset-30 col-md-60">

                    <input type="text" class="form-control" name="email" v-model="email"
                           id="email" placeholder="Введите email">
                </div>

                <div class="form-group col-md-offset-30 col-md-60">

                    <input type="text" class="form-control" name="phone" v-model="phone"
                           id="phone" placeholder="Введите телефон">
                </div>

                <div class="form-group col-md-offset-30 col-md-60">

                    <input type="text" class="form-control" name="name" v-model="name"
                           id="name" placeholder="Введите имя">
                </div>

                <div class="form-group col-md-offset-30 col-md-60">

                    <input type="text" class="form-control" name="surname"  v-model="lastname"
                           id="surname" placeholder="Введите фамилию">
                </div>

                <div class="form-group col-md-offset-30 col-md-60">

                    <input type="password" class="form-control" name="pass" v-model="password"
                           id="pass" placeholder="Введите пароль">
                </div>
                <div class="form-group col-md-offset-30 col-md-60">

                    <input type="password" class="form-control" name="pass_p"  v-model="password2"
                           id="pass_p" placeholder="Повторите пароль">
                </div>
                <div class="form-group col-md-offset-30 col-md-60">
                    <button type="submit" class="btn btn-primary"  @click="sendReg">Регистрация</button>
                </div>

            </div>

            <div class="col-xs-120 text_raw_main_div">
                <h3>Как хорошо и выгодно быть с нами!</h3>
                <ol>
                    <li>Деньги сразу за регистрацию на счет</li>
                    <li>Пригласили друга – получили еще бонус!</li>
                    <li>После ремонта оставили отзыв – начисляем реальными деньгами</li>
                    <li>От каждого ремонта – Cash Back</li>
                    <li>Вступайте в группы в соцсетях и скачивайте приложение – мы оплатим!</li>
                </ol>
                <h3>Тратьте их на ремонт или полезные товары</h3>
                <p>А еще:</p>
                <ul>
                    <li>Поздравим с днем рождения</li>
                    <li>Напомним об окончании полиса страхования и оформим без своей комиссии</li>
                    <li>Много других полезных «плюшек» и разных приятных моментов</li>
                </ul>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'registration',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      errors: '',
      email: '',
      phone: '',
      name: '',
      lastname: '',
      password: '',
      password2: ''
    }
  },
  updated () {
    if (this.auth.id) window.location.href = '/cabinet/'
  },
  created () {
    if (this.auth.id) window.location.href = '/cabinet/'
  },
  mounted () {
    if (this.auth.id) window.location.href = '/cabinet/'
  },
  methods: {
    sendReg () {
      var errors = []
      var $this = this
      if (!this.email && !this.phone) errors.push('Необходимо заполнить почту или телефон')
      if (!this.password) errors.push('Необходимо заполнить пароль')
      if (!this.password2) errors.push('Необходимо заполнить подтверждение пароля')
      if (this.password !== this.password2) errors.push('Пароли не совпадают')
      if (!this.name) errors.push('Необходимо заполнить имя')
      if (errors.length === 0) {
        var formData = new FormData()
        formData.append('email', this.email)
        formData.append('phone', this.phone)
        formData.append('name', this.name)
        formData.append('lastname', this.lastname)
        formData.append('password', this.password)
        formData.append('bonus', this.city.bonus)
        formData.append('city', this.city.id)
        formData.append('uid', this.user.uid)
        axios.post('https://crm.v-avtoservice.com/list/site-reg',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function (response) {
          console.log(response.data)
          if (response.data.title) $this.errors = response.data.text
          else window.location.href = '/cabinet/'
        })
          .catch(function () {
          })
      }
      this.errors = errors.join('<br>')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cabinet/registration.vue